import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, ExternalLink, Github, Monitor, Smartphone, Star, Eye, ArrowRight, Sparkles, TrendingUp } from 'lucide-react';
import Navbar from "../components/Navbar";

const PortfolioSection = () => {
  const [selectedProject, setSelectedProject] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [activeCategory, setActiveCategory] = useState('All');

  const projects = [
    {
      id: 1,
      title: "Cab Booking App",
      description: "Next-generation ride-sharing platform with real-time tracking, AI route optimization, and seamless payment integration.",
      tech: ["React Native", "Firebase", "Maps API", "WebRTC"],
      category: "Mobile App",
      color: "teal",
      stats: { users: "500+", rating: "4.8", growth: "+95%" },
      images: [
        "/assets/portfolio/Firstpage.png",
        "/assets/portfolio/otp.png",
        "/assets/portfolio/home1.png"
      ],
      playStoreUrl: "https://play.google.com/store/apps/details?id=com.cabbooking",
      // appStoreUrl: "https://apps.apple.com/app/cab-booking/id123456789"
    },
    {
      id: 2,
      title: "Education Platform",
      description: "Revolutionary learning management system with VR integration, adaptive learning paths, and real-time collaboration tools.",
      tech: ["React Native", "Node.js", "PostgreSQL", "AWS", "VR"],
      category: "Mobile App",
      color: "green",
      stats: { users: "1000+", rating: "4.9", growth: "+180%" },
      images: [
        "/assets/portfolio/edu1.jpeg",
        "/assets/portfolio/edu2.jpeg",
        "/assets/portfolio/edu3.jpeg"
      ],
      playStoreUrl: "https://play.google.com/store/apps/details?id=com.education",
      // appStoreUrl: "https://apps.apple.com/app/education-platform/id123456789"
    },
     {
      id: 3,
      title: "TBill - Restaurant Billing App",
      description: "Smart restaurant billing solution with GST compliance, table management, inventory tracking, and real-time analytics for seamless restaurant operations.",
      tech: ["React Native", "Node.js", "MongoDB", "Payment Gateway", "Cloud"],
      category: "Mobile App",
      color: "rose",
      stats: { users: "1k+", rating: "4.8", growth: "+140%" },
      images: [
        "/assets/portfolio/tbill1.jpg",
        "/assets/portfolio/tbill2.jpg",
        "/assets/portfolio/tbill3.jpg"
      ],
      playStoreUrl: "https://play.google.com/store/search?q=Tbill&c=apps&hl=en_IN",
      appStoreUrl: "https://apps.apple.com/app/tbill/id123456789"
    },
    {
      id: 4,
      title: "RetailMitra - Retail Billing App",
      description: "All-in-one retail management app with QR-based ordering, POS system, inventory management, customer loyalty programs, and comprehensive business analytics.",
      tech: ["React Native", "QR Integration", "Firebase", "Analytics", "Payment API"],
      category: "Mobile App",
      color: "cyan",
      stats: { users: "1.5K+", rating: "4.9", growth: "+75%" },
      images: [
        "/assets/portfolio/retailmitra1.jpeg",
        "/assets/portfolio/retailmitra2.jpeg",
        "/assets/portfolio/retailmitra3.jpeg"
      ],
      playStoreUrl: "https://play.google.com/store/apps/details?id=com.retailmitra&hl=en_IN",
      appStoreUrl: "https://apps.apple.com/app/retailmitra/id123456789"
    },
    {
      id: 5,
      title: "Restaurant POS System",
      description: "AI-powered point-of-sale ecosystem with predictive inventory, customer analytics, and seamless kitchen automation.",
      tech: ["React", "GraphQL", "Docker", "Redis", "AI"],
      category: "Web Development",
      color: "purple",
      stats: { users: "15K+", rating: "4.7", growth: "+150%" },
      images: [
        "/assets/portfolio/restro1.jpeg",
        "/assets/portfolio/restro2.jpeg",
        "/assets/portfolio/restro3.jpeg"
      ],
      liveUrl: "https://restaurant-pos.com",
      githubUrl: "https://github.com/project/pos"
    },
    {
      id: 6,
      title: "Inventory Management",
      description: "Blockchain-enabled supply chain platform with AR visualization, predictive analytics, and automated procurement systems.",
      tech: ["React Native", "Blockchain", "AR", "ML"],
      category: "Mobile App",
      color: "indigo",
      stats: { users: "30K+", rating: "4.8", growth: "+165%" },
      images: [
        "/assets/portfolio/invt2.jpeg",
        "/assets/portfolio/invt1.jpeg",
        "/assets/portfolio/invt.jpeg"
      ],
      playStoreUrl: "https://play.google.com/store/apps/details?id=com.inventory",
      appStoreUrl: "https://apps.apple.com/app/inventory-management/id123456789"
    },
     {
      id: 7,
      title: "HealthCare Platform",
      description: "A comprehensive healthcare platform offering online appointment booking, patient management, and secure medical record access with AI-powered diagnostics.",
      tech: ["React", "Node.js", "MongoDB", "Stripe", "AI/ML"],
      category: "Web Development",
      color: "blue",
      stats: { users: "1K+", rating: "4.9", growth: "+125%" },
      images: [
        "/assets/portfolio/img1.jpeg",
        "/assets/portfolio/img2.jpeg",
        "/assets/portfolio/img3.jpeg"
      ],
      liveUrl: "https://healthcare-platform.com",
      githubUrl: "https://github.com/project/healthcare"
    },
    {
      id: 8,
      title: "Smart City Dashboard",
      description: "IoT-powered smart city management platform with real-time analytics, predictive maintenance, and citizen engagement tools.",
      tech: ["React", "IoT", "ML", "WebGL", "D3.js"],
      category: "Web Development",
      color: "orange",
      stats: { users: "5K+", rating: "5.0", growth: "+200%" },
      images: [
        "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1f?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=600&fit=crop"
      ],
      liveUrl: "https://smartcity-dashboard.com",
      githubUrl: "https://github.com/project/smartcity"
    },
    {
  id: 9,
  title: "AcePrep – Competitive Exam App",
  description: "All-in-one competitive exam preparation app with mock tests, AI-based performance analysis, daily quizzes, and personalized study plans.",
  tech: ["React Native", "Node.js", "Firebase", "AI", "Stripe"],
  category: "Mobile App",
  color: "blue",
  stats: { users: "25K+", rating: "4.8", growth: "+180%" },
  images: [
    "/assets/portfolio/edo1.jpeg",
    "/assets/portfolio/edo2.jpeg",
    "/assets/portfolio/edo3.jpeg",
    "/assets/portfolio/edu4.jpeg",
  ],
  liveUrl: "https://aceprep-app.com",
  githubUrl: "https://github.com/project/aceprep"
},
{
  id: 10,
  title: "Medi App – Healthcare App",
  description: "Smart healthcare mobile app for online doctor consultations, appointment booking, digital prescriptions, and health record management.",
  tech: ["React Native", "Node.js", "MongoDB", "WebRTC", "AWS"],
  category: "Mobile App",
  color: "green",
  stats: { users: "40K+", rating: "4.9", growth: "+220%" },
  images: [
    "/assets/portfolio/d1.jpeg",
    "/assets/portfolio/d2.jpeg",
    "/assets/portfolio/d3.jpeg",
  ],
  liveUrl: "https://medicareplus-app.com",
  githubUrl: "https://github.com/project/medicareplus"
},

   
  ];

  const categories = ['All', 'Web Development', 'Mobile App'];

  const filteredProjects = activeCategory === 'All' 
    ? projects 
    : projects.filter(p => p.category === activeCategory);

  const currentProject = filteredProjects[selectedProject];

  // Auto-play functionality
  useEffect(() => {
    if (isAutoPlaying && currentProject?.images.length > 1) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) =>
          prev === currentProject.images.length - 1 ? 0 : prev + 1
        );
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [isAutoPlaying, currentProject, currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === currentProject.images.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? currentProject.images.length - 1 : prev - 1
    );
  };

  const nextProject = () => {
    setSelectedProject((prev) =>
      prev === filteredProjects.length - 1 ? 0 : prev + 1
    );
    setCurrentSlide(0);
  };

  const prevProject = () => {
    setSelectedProject((prev) =>
      prev === 0 ? filteredProjects.length - 1 : prev - 1
    );
    setCurrentSlide(0);
  };

  const colors = {
    teal: { gradient: 'from-teal-600 to-teal-800', bg: 'bg-teal-50', text: 'text-teal-700', border: 'border-teal-200' },
    green: { gradient: 'from-green-600 to-green-800', bg: 'bg-green-50', text: 'text-green-700', border: 'border-green-200' },
    rose: { gradient: 'from-rose-600 to-rose-800', bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200' },
    cyan: { gradient: 'from-cyan-600 to-cyan-800', bg: 'bg-cyan-50', text: 'text-cyan-700', border: 'border-cyan-200' },
    purple: { gradient: 'from-purple-600 to-purple-800', bg: 'bg-purple-50', text: 'text-purple-700', border: 'border-purple-200' },
    indigo: { gradient: 'from-indigo-600 to-indigo-800', bg: 'bg-indigo-50', text: 'text-indigo-700', border: 'border-indigo-200' },
    blue: { gradient: 'from-blue-600 to-blue-800', bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200' },
    orange: { gradient: 'from-orange-600 to-orange-800', bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-200' }
  }[currentProject?.color] || { gradient: 'from-red-600 to-red-800', bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200' };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;900&family=JetBrains+Mono:wght@400;500&display=swap');
        
        .font-display {
          font-family: 'Inter', sans-serif;
          font-weight: 900;
        }
        
        .font-mono-body {
          font-family: 'JetBrains Mono', monospace;
          font-weight: 400;
        }
        
        .font-heading {
          font-family: 'Inter', sans-serif;
          font-weight: 700;
        }

        .slide-image {
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .project-card {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        @media (hover: hover) {
          .project-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
          }

          .project-thumbnail:hover .slide-image {
            transform: scale(1.05);
          }
        }

        @media (max-width: 768px) {
          .project-card:active {
            transform: scale(0.98);
          }
        }

        .nav-button {
          transition: all 0.2s ease;
        }

        @media (hover: hover) {
          .nav-button:hover {
            transform: scale(1.05);
          }
        }

        .nav-button:active {
          transform: scale(0.95);
        }

        /* Mobile-specific optimizations */
        @media (max-width: 640px) {
          .font-display {
            font-size: clamp(1.5rem, 7vw, 2.25rem);
          }
        }

        /* Smooth slide transitions */
        .slide-container {
          position: relative;
          overflow: hidden;
        }

        .slide-wrapper {
          display: flex;
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }
      `}</style>

      <Navbar />

      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-red-50 py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-red-50 rounded-full border border-red-200 mb-4 sm:mb-6">
              <Sparkles size={16} className="text-red-700" />
              <span className="text-xs sm:text-sm font-heading text-red-700">Our Success Stories</span>
            </div>
            {/* <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display text-gray-900 mb-3 sm:mb-4 px-4 leading-tight">
              Featured Projects
            </h1> */}
               <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-display text-gray-900 mb-6 leading-tight">
                Featured{" "}
                <span className="bg-gradient-to-r from-red-600 to-red-800 bg-clip-text text-transparent">
                  Projects
                </span>
              </h1>
              
              <div className="w-32 h-1.5 bg-gradient-to-r from-red-600 to-red-800 mx-auto mb-8 rounded-full"></div>
              
            
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto font-mono-body mb-6 sm:mb-8 px-4 leading-relaxed">
              Explore our portfolio of innovative solutions that have transformed businesses across industries
            </p>

            {/* Category Filter */}
            <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => {
                    setActiveCategory(category);
                    setSelectedProject(0);
                    setCurrentSlide(0);
                  }}
                  className={`px-4 sm:px-6 py-2 sm:py-2.5 rounded-lg sm:rounded-xl font-heading text-sm sm:text-base transition-all duration-200 ${
                    activeCategory === category
                      ? 'bg-red-700 text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-red-50 border border-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Main Project Showcase */}
          <div className="bg-white rounded-2xl sm:rounded-3xl shadow-2xl overflow-hidden border border-gray-100 mb-8 sm:mb-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
              {/* Image Gallery */}
              <div className="relative bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center p-6 sm:p-8 lg:p-12 min-h-[500px] sm:min-h-[600px] lg:min-h-0">
                {currentProject?.category === 'Mobile App' ? (
                  // Mobile Phone Frame
                  <div className="relative w-full max-w-[280px] sm:max-w-[320px] mx-auto">
                    {/* Phone Frame */}
                    <div className="relative bg-gray-900 rounded-[36px] sm:rounded-[48px] p-2 sm:p-3 shadow-2xl border-8 sm:border-[12px] border-gray-800">
                      {/* Notch */}
                      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 sm:w-40 h-5 sm:h-6 bg-gray-900 rounded-b-2xl sm:rounded-b-3xl z-10"></div>
                      
                      {/* Screen */}
                      <div className="relative bg-white rounded-[28px] sm:rounded-[36px] overflow-hidden aspect-[9/19.5]">
                        <div className="slide-container h-full">
                          <div 
                            className="slide-wrapper h-full"
                            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                          >
                            {currentProject?.images.map((image, index) => (
                              <div key={index} className="min-w-full h-full flex-shrink-0">
                                <img
                                  src={image}
                                  alt={`${currentProject.title} - Slide ${index + 1}`}
                                  className="w-full h-full object-cover"
                                  onError={(e) => {
                                    e.target.src = `https://via.placeholder.com/400x800/8b0000/ffffff?text=${encodeURIComponent(currentProject.title)}`;
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      
                      {/* Home Indicator */}
                      <div className="absolute bottom-1 sm:bottom-2 left-1/2 -translate-x-1/2 w-24 sm:w-32 h-1 sm:h-1.5 bg-gray-700 rounded-full"></div>
                    </div>
                    
                    {/* Power Button */}
                    <div className="absolute right-0 top-24 sm:top-28 w-1 sm:w-1.5 h-12 sm:h-16 bg-gray-800 rounded-l-lg"></div>
                    
                    {/* Volume Buttons */}
                    <div className="absolute left-0 top-20 sm:top-24 w-1 sm:w-1.5 h-8 sm:h-10 bg-gray-800 rounded-r-lg"></div>
                    <div className="absolute left-0 top-32 sm:top-38 w-1 sm:w-1.5 h-8 sm:h-10 bg-gray-800 rounded-r-lg"></div>
                  </div>
                ) : (
                  // Browser Frame
                  <div className="relative w-full max-w-[500px] sm:max-w-[600px] mx-auto">
                    {/* Browser Window */}
                    <div className="bg-gray-800 rounded-t-lg sm:rounded-t-xl overflow-hidden shadow-2xl">
                      {/* Browser Header */}
                      <div className="bg-gray-700 px-3 sm:px-4 py-2 sm:py-3 flex items-center gap-2">
                        <div className="flex gap-1.5 sm:gap-2">
                          <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-red-500"></div>
                          <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-yellow-500"></div>
                          <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-green-500"></div>
                        </div>
                        <div className="flex-1 mx-2 sm:mx-4 bg-gray-600 rounded px-2 sm:px-3 py-1 sm:py-1.5">
                          <div className="flex items-center gap-1.5 sm:gap-2">
                            <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                            <span className="text-[10px] sm:text-xs text-gray-300 font-mono-body truncate">
                              {currentProject?.liveUrl || 'https://example.com'}
                            </span>
                          </div>
                        </div>
                      </div>
                      
                      {/* Browser Content */}
                      <div className="relative bg-white aspect-[16/10] overflow-hidden">
                        <div className="slide-container h-full">
                          <div 
                            className="slide-wrapper h-full"
                            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                          >
                            {currentProject?.images.map((image, index) => (
                              <div key={index} className="min-w-full h-full flex-shrink-0">
                                <img
                                  src={image}
                                  alt={`${currentProject.title} - Slide ${index + 1}`}
                                  className="w-full h-full object-cover"
                                  onError={(e) => {
                                    e.target.src = `https://via.placeholder.com/800x500/8b0000/ffffff?text=${encodeURIComponent(currentProject.title)}`;
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                
                {/* Navigation Controls */}
                <div className="absolute inset-0 flex items-center justify-between px-2 sm:px-4 pointer-events-none">
                  <button
                    onClick={prevSlide}
                    className="pointer-events-auto p-2 sm:p-3 bg-white/90 hover:bg-white rounded-full shadow-lg transition-all duration-200 group z-20"
                  >
                    <ChevronLeft size={20} className="text-gray-900 sm:w-6 sm:h-6" />
                  </button>
                  <button
                    onClick={nextSlide}
                    className="pointer-events-auto p-2 sm:p-3 bg-white/90 hover:bg-white rounded-full shadow-lg transition-all duration-200 group z-20"
                  >
                    <ChevronRight size={20} className="text-gray-900 sm:w-6 sm:h-6" />
                  </button>
                </div>

                {/* Slide Indicators */}
                <div className="absolute bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 flex gap-1.5 sm:gap-2 z-20">
                  {currentProject?.images.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className={`h-1.5 sm:h-2 rounded-full transition-all duration-300 ${
                        index === currentSlide
                          ? 'bg-white w-6 sm:w-8'
                          : 'bg-white/50 w-1.5 sm:w-2 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>

                {/* Auto-play Toggle */}
                <button
                  onClick={() => setIsAutoPlaying(!isAutoPlaying)}
                  className="absolute top-3 sm:top-4 right-3 sm:right-4 p-2 sm:p-2.5 bg-white/90 hover:bg-white rounded-full shadow-lg transition-all duration-200 z-20"
                >
                  {isAutoPlaying ? (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                      <rect x="6" y="4" width="4" height="16" />
                      <rect x="14" y="4" width="4" height="16" />
                    </svg>
                  ) : (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  )}
                </button>

                {/* Category Badge */}
                <div className="absolute top-3 sm:top-4 left-3 sm:left-4 z-20">
                  <div className={`flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-white/95 backdrop-blur-sm rounded-lg sm:rounded-xl shadow-lg border ${colors.border}`}>
                    {currentProject?.category === 'Mobile App' ? (
                      <Smartphone size={14} className={`${colors.text} sm:w-4 sm:h-4`} />
                    ) : (
                      <Monitor size={14} className={`${colors.text} sm:w-4 sm:h-4`} />
                    )}
                    <span className={`text-xs sm:text-sm font-heading ${colors.text}`}>
                      {currentProject?.category}
                    </span>
                  </div>
                </div>
              </div>

              {/* Project Details */}
              <div className="p-6 sm:p-8 lg:p-12 flex flex-col">
                <div className="flex-1 space-y-6 sm:space-y-8">
                  {/* Header */}
                  <div>
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4 mb-4 sm:mb-6">
                      <div className="flex-1">
                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-display text-gray-900 mb-2 sm:mb-3">
                          {currentProject?.title}
                        </h2>
                        <div className="flex items-center gap-2 text-xs sm:text-sm text-gray-500 font-mono-body">
                          <span className="flex items-center gap-1">
                            <Eye size={14} className="sm:w-4 sm:h-4" />
                            {currentProject?.stats.users} users
                          </span>
                          <span>•</span>
                          <span className="flex items-center gap-1">
                            <Star size={14} className="text-amber-400 fill-amber-400 sm:w-4 sm:h-4" />
                            {currentProject?.stats.rating}
                          </span>
                        </div>
                      </div>

                      <div className="flex sm:flex-col gap-2">
                        {currentProject?.githubUrl && (
                          <a
                            href={currentProject.githubUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-2.5 sm:p-3 bg-gray-100 hover:bg-gray-200 rounded-lg sm:rounded-xl transition-colors group"
                            title="View on GitHub"
                          >
                            <Github size={18} className="text-gray-700 sm:w-5 sm:h-5" />
                          </a>
                        )}
                        {currentProject?.liveUrl && (
                          <a
                            href={currentProject.liveUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-2.5 sm:p-3 bg-gray-100 hover:bg-gray-200 rounded-lg sm:rounded-xl transition-colors group"
                            title="View Live"
                          >
                            <ExternalLink size={18} className="text-gray-700 sm:w-5 sm:h-5" />
                          </a>
                        )}
                      </div>
                    </div>

                    {/* Stats Bar */}
                    <div className="flex flex-wrap items-center gap-3 sm:gap-6 p-3 sm:p-4 bg-red-50 rounded-xl border border-red-100">
                      <div className="flex items-center gap-2">
                        <Eye size={16} className="text-red-700 sm:w-5 sm:h-5" />
                        <div>
                          <div className="text-xs sm:text-sm font-heading text-gray-900">{currentProject?.stats.users}</div>
                          <div className="text-[10px] sm:text-xs text-gray-600 font-mono-body">Active Users</div>
                        </div>
                      </div>
                      <div className="w-px h-8 sm:h-10 bg-red-200"></div>
                      <div className="flex items-center gap-2">
                        <Star size={16} className="text-amber-400 fill-amber-400 sm:w-5 sm:h-5" />
                        <div>
                          <div className="text-xs sm:text-sm font-heading text-gray-900">{currentProject?.stats.rating}</div>
                          <div className="text-[10px] sm:text-xs text-gray-600 font-mono-body">Rating</div>
                        </div>
                      </div>
                      <div className="w-px h-8 sm:h-10 bg-red-200"></div>
                      <div className="flex items-center gap-2">
                        <TrendingUp size={16} className="text-red-700 sm:w-5 sm:h-5" />
                        <div>
                          <div className="text-xs sm:text-sm font-heading text-red-700">{currentProject?.stats.growth}</div>
                          <div className="text-[10px] sm:text-xs text-gray-600 font-mono-body">Growth</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Description */}
                  <div>
                    <h3 className="text-xs sm:text-sm font-heading text-gray-900 mb-2 sm:mb-3 uppercase tracking-wider">Project Overview</h3>
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed font-mono-body">
                      {currentProject?.description}
                    </p>
                  </div>

                  {/* Tech Stack */}
                  <div>
                    <h3 className="text-xs sm:text-sm font-heading text-gray-900 mb-2 sm:mb-3 uppercase tracking-wider">Technology Stack</h3>
                    <div className="flex flex-wrap gap-2">
                      {currentProject?.tech.map((tech, index) => (
                        <span
                          key={index}
                          className="px-3 sm:px-4 py-1.5 sm:py-2 bg-red-50 text-red-700 rounded-lg text-xs sm:text-sm font-mono-body border border-red-100 hover:bg-red-100 transition-colors duration-200"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* CTA Button */}
                  {currentProject?.category === 'Mobile App' ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {currentProject?.playStoreUrl && (
                        <a
                          href={currentProject.playStoreUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`group py-3 sm:py-4 rounded-xl font-heading text-white bg-gradient-to-r ${colors.gradient} hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 text-sm sm:text-base`}
                        >
                          <svg className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.802 8.99l-2.303 2.303-8.635-8.635z"/>
                          </svg>
                          <span>Google Play</span>
                        </a>
                      )}
                      {currentProject?.appStoreUrl && (
                        <a
                          href={currentProject.appStoreUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`group py-3 sm:py-4 rounded-xl font-heading text-white bg-gradient-to-r ${colors.gradient} hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 text-sm sm:text-base`}
                        >
                          <svg className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                          </svg>
                          <span>App Store</span>
                        </a>
                      )}
                    </div>
                  ) : (
                    <a
                      href={currentProject?.liveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`w-full group py-3 sm:py-4 rounded-xl font-heading text-white bg-gradient-to-r ${colors.gradient} hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 text-sm sm:text-base`}
                    >
                      <span>View Live Website</span>
                      <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform sm:w-5 sm:h-5" />
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Project Navigation */}
          <div className="mt-8 sm:mt-12">
            <div className="flex items-center justify-between mb-4 sm:mb-6">
              <h3 className="text-lg sm:text-xl font-heading text-gray-900">
                More Projects ({filteredProjects.length})
              </h3>
              <div className="flex gap-2">
                <button
                  onClick={prevProject}
                  className="nav-button p-2 sm:p-3 bg-white hover:bg-red-50 rounded-lg sm:rounded-xl shadow-md border border-gray-200"
                >
                  <ChevronLeft size={18} className="text-gray-700 sm:w-5 sm:h-5" />
                </button>
                <button
                  onClick={nextProject}
                  className="nav-button p-2 sm:p-3 bg-white hover:bg-red-50 rounded-lg sm:rounded-xl shadow-md border border-gray-200"
                >
                  <ChevronRight size={18} className="text-gray-700 sm:w-5 sm:h-5" />
                </button>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
              {filteredProjects.map((project, index) => (
                <button
                  key={project.id}
                  onClick={() => {
                    setSelectedProject(index);
                    setCurrentSlide(0);
                  }}
                  className={`project-card project-thumbnail text-left rounded-lg sm:rounded-xl overflow-hidden border-2 transition-all duration-300 ${
                    index === selectedProject
                      ? 'border-red-700 shadow-lg'
                      : 'border-gray-200 hover:border-red-300'
                  }`}
                >
                  <div className="relative aspect-[3/4] bg-gray-900 overflow-hidden">
                    <img
                      src={project.images[0]}
                      alt={project.title}
                      className="slide-image w-full h-full object-cover"
                      onError={(e) => {
                        e.target.src = `https://via.placeholder.com/300x400/8b0000/ffffff?text=${encodeURIComponent(project.title)}`;
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-2 sm:p-3">
                      <h4 className="text-white text-xs sm:text-sm font-heading mb-0.5 sm:mb-1 line-clamp-1">{project.title}</h4>
                      <p className="text-white/80 text-[10px] sm:text-xs font-mono-body line-clamp-1">{project.category}</p>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Spacing */}
        <div className="h-12 sm:h-20"></div>
      </div>
    </>
  );
};

export default PortfolioSection;